import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, switchMap, take } from 'rxjs';
import { AuthorizationTokenService, BridgeTokenConfigProviderService, ComposeUrlService, EnviromentContextService, WINDOW } from 'common';

@Injectable({
  providedIn: 'root'
})
export class BlobStorageService {

  constructor(
    private http: HttpClient,
    private composeUrlService: ComposeUrlService,
    private authorizationTokenService: AuthorizationTokenService,
    private bridgeTokenConfigProviderService: BridgeTokenConfigProviderService,
    private enviromentContextService: EnviromentContextService,
    @Inject(WINDOW) private window: Window
  ) { }

  private getCode(): HttpParams {
    const code = this.bridgeTokenConfigProviderService.getCode();
    let params = new HttpParams();
    if (code !== undefined) {
      params = params.set('code', code);
    }
    return params;
  }

  uploadFile(file: File, enviromentBaseDir: string): Observable<{ fileName: string }> {
    const url = this.composeUrlService.composeToolsUrl('fileUploadStorage');
    const site = this.window.location.hostname;
    const company = this.enviromentContextService.getCompany() ?? '';
    const environment = this.enviromentContextService.getEnviroment() ?? '';

    return this.authorizationTokenService.getExternalToken().pipe(
      take(1),
      switchMap(token => {
        const formData = new FormData();
        formData.append('site', site);
        formData.append('company', company);
        formData.append('environment', environment);
        formData.append('enviromentBaseDir', enviromentBaseDir);
        formData.append('fileName', file.name);
        formData.append('file', file, file.name);

        return this.http.post<{ fileName: string }>(url, formData, {
          headers: new HttpHeaders({ 'Authorization': `Bearer ${token}` }),
          params: this.getCode()
        });
      })
    );
  }

  downloadFile(fileName: string, enviromentBaseDir: string): Observable<Blob> {
    const url = this.composeUrlService.composeToolsUrl('fileDownloadStorage');
    const site = this.window.location.hostname;
    const company = this.enviromentContextService.getCompany() ?? '';
    const environment = this.enviromentContextService.getEnviroment() ?? '';

    return this.authorizationTokenService.getExternalToken().pipe(
      take(1),
      switchMap(token => {
        let params = this.getCode()
          .set('site', site)
          .set('company', company)
          .set('environment', environment)
          .set('enviromentBaseDir', enviromentBaseDir)
          .set('fileName', fileName);

        return this.http.get(url, {
          headers: new HttpHeaders({ 'Authorization': `Bearer ${token}` }),
          params,
          responseType: 'blob'
        });
      })
    );
  }
}
